export default "__VITE_ASSET__3TcC7Byl__"